import Grid from '../components/grid';
import Button from '../components/ui/button';
import Container from '../components/ui/container';
import Text from '../components/ui/text';
import React, { ReactElement } from 'react';
import { BsArrowUpRight } from 'react-icons/bs';

interface Props {
  text: string;
  link: any;
  overlayColor?: string;
}

function InfoVideoCTAButton({ text, link, overlayColor }: Props): ReactElement {
  return (
    <Container>
      <Grid>
        <Text className="col-span-full lg:col-span-6 ">{text}</Text>

        <div
          className={`col-span-full lg:col-span-6 relative flex justify-center p-10 ${
            overlayColor ? `bg-${overlayColor}` : 'bg-telesoft'
          } text-white min-h-[280px] overflow-hidden`}
        >
          <Button
            onClick={() => {
              document
                .getElementById('contact-form')!
                .scrollIntoView({ behavior: 'smooth', block: 'center' });
            }}
            variant="flat"
            className="w-full text-white z-10 text-xl"
          >
            {link.label ? link.label : 'Get Started'}
            <BsArrowUpRight className="ml-1" />
          </Button>
          <div className="absolute inset-0 opacity-25">
            <video
              id="vid"
              loop
              autoPlay
              width="100%"
              className="z-10 object-cover"
              playsInline
              muted
              height="100%"
            >
              <source src="/assets/video/home-test.mp4" type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </div>
        </div>
      </Grid>
    </Container>
  );
}

export default InfoVideoCTAButton;
